const handleClickFindTargetPath = (targetNodeId, nodes, edges) => {
    const targetNode = nodes.find(node => node.id === targetNodeId);
    if (!targetNode) return [];

    const incomingEdges = edges.filter(edge => edge.target === targetNodeId);
    const outgoingEdges = edges.filter(edge => edge.source === targetNodeId);

    // กรณี alone node (ไม่มี connection เข้าและออก)
    if (incomingEdges.length === 0 && outgoingEdges.length === 0) {
        return [{ pathNodes: [targetNodeId], startNode: targetNodeId, pathType: "alone", pathEdges: [] }];
    }

    // ฟังก์ชันหา start nodes
    function findStartNodes(nodeId, visited = new Set(), startNodes = new Set()) {
        if (visited.has(nodeId)) return;
        visited.add(nodeId);

        const targetNode = nodes.find(n => n.id === nodeId);
        if (targetNode?.type === 'subject') {
            startNodes.add(nodeId);
            return;
        }

        const incoming = edges.filter(edge => edge.target === nodeId);

        if (incoming.length === 0) {
            startNodes.add(nodeId);
            return;
        }

        for (const edge of incoming) {
            const sourceNode = nodes.find(n => n.id === edge.source);
            if (!sourceNode) continue;

            if (sourceNode.type === 'subject') {
                startNodes.add(sourceNode.id);
            } else {
                findStartNodes(sourceNode.id, visited, startNodes);
            }
        }
    }

    // หา start nodes และเก็บค่าซ้ำใน Set เพื่อไม่ให้มี start node ซ้ำ
    let startNodeIds = new Set();
    findStartNodes(targetNodeId, new Set(), startNodeIds);

    // console.log("startNodeIds: ", startNodeIds);

    // ฟังก์ชันหา path โดยห้ามมี subject มากกว่า 1 ตัว
    function findPaths(startNodeId, currentNodeId, visited = new Set(), currentPath = []) {
        if (visited.has(currentNodeId)) return [];
        visited.add(currentNodeId);

        const newPath = [...currentPath, currentNodeId];
        const subjectCount = newPath.filter(nodeId => {
            const node = nodes.find(n => n.id === nodeId);
            return node?.type === 'subject';
        }).length;

        if (subjectCount > 1) return []; // ตัด path ที่มี subject มากกว่า 1 ตัว

        const outgoing = edges.filter(edge => edge.source === currentNodeId);
        if (outgoing.length === 0) {
            return [newPath];
        }

        let paths = [];
        for (const edge of outgoing) {
            const subPaths = findPaths(startNodeId, edge.target, new Set(visited), newPath);
            paths.push(...subPaths);
        }
        return paths;
    }

    // หา path ที่รวม target node และกรอง path ที่มี subject ซ้ำ
    let resultPaths = [];
    for (const startNodeId of startNodeIds) {
        const paths = findPaths(startNodeId, startNodeId)
            .filter(path => path.includes(targetNodeId)); // ต้องมี target node ใน path

        for (const path of paths) {
            const startNode = nodes.find(n => n.id === startNodeId);
            const endNode = nodes.find(n => n.id === path[path.length - 1]);
            const pathType = (startNode?.type === "subject" && endNode?.type === "root") ? "full path" : "island";

            // หา pathEdges จากการเชื่อมต่อระหว่างโหนดในแต่ละ path
            const pathEdges = [];
            for (let i = 0; i < path.length - 1; i++) {
                const edge = edges.find(e => e.source === path[i] && e.target === path[i + 1]);
                if (edge) {
                    pathEdges.push(edge.id);
                }
            }

            resultPaths.push({ pathNodes: path, startNode: startNodeId, pathType: pathType, pathEdges: pathEdges });
        }
    }

    if (
        startNodeIds.size === 1 && // มีแค่ startNodeId เดียว
        startNodeIds.has(targetNodeId) && // startNodeId นั้นตรงกับ targetNodeId
        targetNode.type === "subject" && // targetNode เป็น subject
        (incomingEdges.length > 0 || outgoingEdges.length > 0) && // มี connection เข้า หรือ ออก
        resultPaths.length === 0 // ไม่มี path ที่หาได้
    ) {
        resultPaths.push({ pathNodes: [targetNodeId], startNode: targetNodeId, pathType: "island", pathEdges: [] });
    }

    return resultPaths;
};

export default handleClickFindTargetPath;
